// [COMPONENT_ROUTES_IMPORTS_START]
import BgtPage from "../pages/bgtPage/BgtPage";
import RealisticIsraelPage from "../pages/realisticIsrael/RealisticIsraelPage";
import FinalProjectsPage from "../pages/finalProjects/finalProjectPage/FinalProjectsPage";
// [COMPONENT_ROUTES_IMPORTS_END]

// [COMPONENT_ROUTES_TYPE_START]
const ComponentsRoutesTypeStudent = {
    bgt: BgtPage,
    realisticIsrael: RealisticIsraelPage,
    finalProjects: FinalProjectsPage
}
// [COMPONENT_ROUTES_TYPE_END]
export default ComponentsRoutesTypeStudent